import { render, staticRenderFns } from "./details.vue?vue&type=template&id=14c8a4c3&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=14c8a4c3&prod&lang=scss&scoped=true"
import style1 from "./details.vue?vue&type=style&index=1&id=14c8a4c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c8a4c3",
  null
  
)

export default component.exports